/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LANGUAGE = "DANISH" | "ENGLISH_EU" | "ENGLISH_UK" | "ENGLISH_US" | "FRENCH" | "POLISH" | "SPANISH" | "%future added value";
export type UpdateViewerInput = {
    email?: string | null | undefined;
    jobTitle?: string | null | undefined;
    firstName?: string | null | undefined;
    lastName?: string | null | undefined;
    phone?: string | null | undefined;
    initials?: string | null | undefined;
    userType?: string | null | undefined;
    roleId?: string | null | undefined;
    profileId?: string | null | undefined;
    departmentId?: string | null | undefined;
    holidayCalendarId?: string | null | undefined;
    language?: LANGUAGE | null | undefined;
    oldPassword?: string | null | undefined;
    newPassword?: string | null | undefined;
    labels?: Array<string | null> | null | undefined;
    profilePictureId?: string | null | undefined;
    notificationFrequency?: number | null | undefined;
    notifyOnProjectStatusChange?: boolean | null | undefined;
    notifyOnPersonJoin?: boolean | null | undefined;
    notifyOnAssignedProject?: boolean | null | undefined;
    notifyOnProjectDeadline?: boolean | null | undefined;
    notifyOnAssignedTask?: boolean | null | undefined;
    notifyOnAssignedTaskUpdate?: boolean | null | undefined;
    notifyOnTaskDeadline?: boolean | null | undefined;
    notifyOnMention?: boolean | null | undefined;
    notifyOnInvoiceDueDate?: boolean | null | undefined;
    notifyOnInvoiceOverdue?: boolean | null | undefined;
    notifyOnInvoiceDaysOverdue?: boolean | null | undefined;
    notifyOnInvoiceCreatedOrDeleted?: boolean | null | undefined;
    notifyOnInvoiceStatusChange?: boolean | null | undefined;
    notifyOnInvoiceDateReached?: boolean | null | undefined;
    notifyOnInvoicePayment?: boolean | null | undefined;
    notifyOnInvoiceDateChanged?: boolean | null | undefined;
    notifyOnInvoiceDueDateChanged?: boolean | null | undefined;
    notifyOnTaskDescriptionChange?: boolean | null | undefined;
    notifyOnTaskTitleChange?: boolean | null | undefined;
    notifyOnTaskEstimateChange?: boolean | null | undefined;
    notifyOnTaskStartDateChange?: boolean | null | undefined;
    notifyOnTaskEndDateChange?: boolean | null | undefined;
    notifyOnTaskSprintChange?: boolean | null | undefined;
    notifyOnTaskPhaseChange?: boolean | null | undefined;
    notifyOnTaskStatusColumnChange?: boolean | null | undefined;
    notifyOnTaskProjectChange?: boolean | null | undefined;
    notifyOnTaskSubtaskChange?: boolean | null | undefined;
    notifyOnTaskSubtaskEstimateChange?: boolean | null | undefined;
    notifyOnTaskCommentChange?: boolean | null | undefined;
    notifyOnTaskFileChange?: boolean | null | undefined;
    notifyOnTaskBugChange?: boolean | null | undefined;
    notifyOnTaskBlockedChange?: boolean | null | undefined;
    notifyOnTaskRepeatingChange?: boolean | null | undefined;
    notifyOnTimeOffManager?: boolean | null | undefined;
    notifyOnTimeOffOwner?: boolean | null | undefined;
    projectDeadlineNotificationPeriod?: number | null | undefined;
    taskDeadlineNotificationPeriod?: number | null | undefined;
    invoiceNotificationDaysOverdue?: number | null | undefined;
    disableNotifications?: boolean | null | undefined;
    notifyInAppOnPersonJoin?: boolean | null | undefined;
    notifyInAppOnProjectStatusChange?: boolean | null | undefined;
    notifyInAppOnAssignedProject?: boolean | null | undefined;
    notifyInAppOnProjectDeadline?: boolean | null | undefined;
    notifyInAppOnAssignedTask?: boolean | null | undefined;
    notifyInAppOnAssignedTaskUpdate?: boolean | null | undefined;
    notifyInAppOnTaskDeadline?: boolean | null | undefined;
    notifyInAppOnMention?: boolean | null | undefined;
    notifyInAppOnInvoiceDueDate?: boolean | null | undefined;
    notifyInAppOnInvoiceOverdue?: boolean | null | undefined;
    notifyInAppOnInvoiceDaysOverdue?: boolean | null | undefined;
    notifyInAppOnInvoiceCreatedOrDeleted?: boolean | null | undefined;
    notifyInAppOnInvoiceStatusChange?: boolean | null | undefined;
    notifyInAppOnInvoiceDateReached?: boolean | null | undefined;
    notifyInAppOnInvoicePayment?: boolean | null | undefined;
    notifyInAppOnInvoiceDateChanged?: boolean | null | undefined;
    notifyInAppOnInvoiceDueDateChanged?: boolean | null | undefined;
    notifyInAppOnTaskDescriptionChange?: boolean | null | undefined;
    notifyInAppOnTaskTitleChange?: boolean | null | undefined;
    notifyInAppOnTaskEstimateChange?: boolean | null | undefined;
    notifyInAppOnTaskStartDateChange?: boolean | null | undefined;
    notifyInAppOnTaskEndDateChange?: boolean | null | undefined;
    notifyInAppOnTaskSprintChange?: boolean | null | undefined;
    notifyInAppOnTaskPhaseChange?: boolean | null | undefined;
    notifyInAppOnTaskStatusColumnChange?: boolean | null | undefined;
    notifyInAppOnTaskProjectChange?: boolean | null | undefined;
    notifyInAppOnTaskSubtaskChange?: boolean | null | undefined;
    notifyInAppOnTaskSubtaskEstimateChange?: boolean | null | undefined;
    notifyInAppOnTaskCommentChange?: boolean | null | undefined;
    notifyInAppOnTaskFileChange?: boolean | null | undefined;
    notifyInAppOnTaskBugChange?: boolean | null | undefined;
    notifyInAppOnTaskBlockedChange?: boolean | null | undefined;
    notifyInAppOnTaskRepeatingChange?: boolean | null | undefined;
    notifyInAppOnTimeOffManager?: boolean | null | undefined;
    notifyInAppOnTimeOffOwner?: boolean | null | undefined;
    lastSeenInAppNotification?: number | null | undefined;
    disableInAppNotifications?: boolean | null | undefined;
    disableCelebrationAnimations?: boolean | null | undefined;
    projectDeadlineInAppNotificationPeriod?: number | null | undefined;
    taskDeadlineInAppNotificationPeriod?: number | null | undefined;
    sendNewsletter?: boolean | null | undefined;
    monday?: number | null | undefined;
    tuesday?: number | null | undefined;
    wednesday?: number | null | undefined;
    thursday?: number | null | undefined;
    friday?: number | null | undefined;
    saturday?: number | null | undefined;
    sunday?: number | null | undefined;
    startDate?: string | null | undefined;
    endDate?: string | null | undefined;
    timerStartDate?: string | null | undefined;
    timerEndDate?: string | null | undefined;
    timerTaskId?: string | null | undefined;
    cost?: number | null | undefined;
    flowSampleStep?: string | null | undefined;
    timeLogPersonId?: string | null | undefined;
    githubPersonId?: string | null | undefined;
    gitlabPersonId?: string | null | undefined;
    gitlabServerPersonId?: string | null | undefined;
    jiraCloudId?: string | null | undefined;
    jiraServerId?: string | null | undefined;
    unit4PersonId?: string | null | undefined;
    sageIntacctId?: string | null | undefined;
    sageIntacctName?: string | null | undefined;
    sageIntacctEmail?: string | null | undefined;
    sageIntacctLocationId?: string | null | undefined;
    adoUserId?: string | null | undefined;
    onboardingInitialStep?: string | null | undefined;
    onboardingProjectPhasesStep?: string | null | undefined;
    onboardingProjectBudgetStep?: string | null | undefined;
    onboardingProjectBoardStep?: string | null | undefined;
    onboardingProjectOverviewStep?: string | null | undefined;
    onboardingTaskModalStep?: string | null | undefined;
    onboardingOverviewTimeStep?: string | null | undefined;
    setToRunningNotificationLastDismissalDate?: string | null | undefined;
    useNewUIWorkflow?: boolean | null | undefined;
    savedFiltersJson?: string | null | undefined;
    adminPassword?: string | null | undefined;
    calendarViewPrivateEvents?: boolean | null | undefined;
    hiBobId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateViewerMutationVariables = {
    input: UpdateViewerInput;
};
export type updateViewerMutationResponse = {
    readonly updateViewer: {
        readonly errors: ReadonlyArray<string | null> | null;
        readonly viewer: {
            readonly email: string | null;
            readonly jobTitle: string | null;
            readonly department: {
                readonly id: string;
                readonly name: string | null;
            } | null;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly phone: string | null;
            readonly initials: string | null;
            readonly cost: number | null;
            readonly profiles: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly name: string | null;
                    } | null;
                } | null> | null;
            } | null;
            readonly role: {
                readonly id: string;
                readonly name: string | null;
            } | null;
            readonly holidayCalendar: {
                readonly id: string;
            } | null;
            readonly language: LANGUAGE | null;
            readonly invited: boolean | null;
            readonly profilePictureId: string | null;
            readonly personLabels: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly label: {
                            readonly id: string;
                        } | null;
                    } | null;
                } | null> | null;
            } | null;
            readonly unseenNotifications: number | null;
            readonly notificationFrequency: number | null;
            readonly notifyOnPersonJoin: boolean | null;
            readonly notifyOnProjectStatusChange: boolean | null;
            readonly notifyOnAssignedProject: boolean | null;
            readonly notifyOnProjectDeadline: boolean | null;
            readonly notifyOnAssignedTask: boolean | null;
            readonly notifyOnAssignedTaskUpdate: boolean | null;
            readonly notifyOnTaskDeadline: boolean | null;
            readonly notifyOnMention: boolean | null;
            readonly notifyOnInvoiceDueDate: boolean | null;
            readonly notifyOnInvoiceOverdue: boolean | null;
            readonly notifyOnInvoiceDaysOverdue: boolean | null;
            readonly notifyOnInvoiceCreatedOrDeleted: boolean | null;
            readonly notifyOnInvoiceStatusChange: boolean | null;
            readonly notifyOnInvoiceDateReached: boolean | null;
            readonly notifyOnInvoicePayment: boolean | null;
            readonly notifyOnInvoiceDateChanged: boolean | null;
            readonly notifyOnInvoiceDueDateChanged: boolean | null;
            readonly notifyOnTaskDescriptionChange: boolean | null;
            readonly notifyOnTaskTitleChange: boolean | null;
            readonly notifyOnTaskEstimateChange: boolean | null;
            readonly notifyOnTaskStartDateChange: boolean | null;
            readonly notifyOnTaskEndDateChange: boolean | null;
            readonly notifyOnTaskSprintChange: boolean | null;
            readonly notifyOnTaskPhaseChange: boolean | null;
            readonly notifyOnTaskStatusColumnChange: boolean | null;
            readonly notifyOnTaskProjectChange: boolean | null;
            readonly notifyOnTaskSubtaskChange: boolean | null;
            readonly notifyOnTaskSubtaskEstimateChange: boolean | null;
            readonly notifyOnTaskCommentChange: boolean | null;
            readonly notifyOnTaskFileChange: boolean | null;
            readonly notifyOnTaskBugChange: boolean | null;
            readonly notifyOnTaskBlockedChange: boolean | null;
            readonly notifyOnTaskRepeatingChange: boolean | null;
            readonly notifyOnTimeOffManager: boolean | null;
            readonly notifyOnTimeOffOwner: boolean | null;
            readonly disableNotifications: boolean | null;
            readonly projectDeadlineNotificationPeriod: number | null;
            readonly taskDeadlineNotificationPeriod: number | null;
            readonly invoiceNotificationDaysOverdue: number | null;
            readonly notifyInAppOnProjectStatusChange: boolean | null;
            readonly notifyInAppOnPersonJoin: boolean | null;
            readonly notifyInAppOnAssignedProject: boolean | null;
            readonly notifyInAppOnProjectDeadline: boolean | null;
            readonly notifyInAppOnAssignedTask: boolean | null;
            readonly notifyInAppOnAssignedTaskUpdate: boolean | null;
            readonly notifyInAppOnTaskDeadline: boolean | null;
            readonly notifyInAppOnMention: boolean | null;
            readonly notifyInAppOnInvoiceDueDate: boolean | null;
            readonly notifyInAppOnInvoiceOverdue: boolean | null;
            readonly notifyInAppOnInvoiceDaysOverdue: boolean | null;
            readonly notifyInAppOnInvoiceCreatedOrDeleted: boolean | null;
            readonly notifyInAppOnInvoiceStatusChange: boolean | null;
            readonly notifyInAppOnInvoiceDateReached: boolean | null;
            readonly notifyInAppOnInvoicePayment: boolean | null;
            readonly notifyInAppOnInvoiceDateChanged: boolean | null;
            readonly notifyInAppOnInvoiceDueDateChanged: boolean | null;
            readonly notifyInAppOnTaskDescriptionChange: boolean | null;
            readonly notifyInAppOnTaskTitleChange: boolean | null;
            readonly notifyInAppOnTaskEstimateChange: boolean | null;
            readonly notifyInAppOnTaskStartDateChange: boolean | null;
            readonly notifyInAppOnTaskEndDateChange: boolean | null;
            readonly notifyInAppOnTaskSprintChange: boolean | null;
            readonly notifyInAppOnTaskPhaseChange: boolean | null;
            readonly notifyInAppOnTaskStatusColumnChange: boolean | null;
            readonly notifyInAppOnTaskProjectChange: boolean | null;
            readonly notifyInAppOnTaskSubtaskChange: boolean | null;
            readonly notifyInAppOnTaskSubtaskEstimateChange: boolean | null;
            readonly notifyInAppOnTaskCommentChange: boolean | null;
            readonly notifyInAppOnTaskFileChange: boolean | null;
            readonly notifyInAppOnTaskBugChange: boolean | null;
            readonly notifyInAppOnTaskBlockedChange: boolean | null;
            readonly notifyInAppOnTaskRepeatingChange: boolean | null;
            readonly notifyInAppOnTimeOffManager: boolean | null;
            readonly notifyInAppOnTimeOffOwner: boolean | null;
            readonly disableInAppNotifications: boolean | null;
            readonly projectDeadlineInAppNotificationPeriod: number | null;
            readonly taskDeadlineInAppNotificationPeriod: number | null;
            readonly lastSeenInAppNotification: number | null;
            readonly sendNewsletter: boolean | null;
            readonly monday: number | null;
            readonly tuesday: number | null;
            readonly wednesday: number | null;
            readonly thursday: number | null;
            readonly friday: number | null;
            readonly saturday: number | null;
            readonly sunday: number | null;
            readonly startDate: string | null;
            readonly endDate: string | null;
            readonly timerStartDate: string | null;
            readonly timerEndDate: string | null;
            readonly timerTask: {
                readonly id: string;
            } | null;
            readonly setToRunningNotificationLastDismissalDate: string | null;
            readonly gitlabUser: {
                readonly integrationUserId: number | null;
            } | null;
            readonly gitlabServerUser: {
                readonly integrationUserId: number | null;
            } | null;
            readonly githubUser: {
                readonly integrationUserId: number | null;
            } | null;
            readonly unit4UserObject: string | null;
            readonly jiraCloudId: string | null;
            readonly jiraServerId: string | null;
            readonly sageIntacctId: string | null;
            readonly sageIntacctName: string | null;
            readonly sageIntacctEmail: string | null;
            readonly sageIntacctLocationId: string | null;
            readonly adoUserId: string | null;
            readonly hiBobId: string | null;
        } | null;
    } | null;
};
export type updateViewerMutation = {
    readonly response: updateViewerMutationResponse;
    readonly variables: updateViewerMutationVariables;
};



/*
mutation updateViewerMutation(
  $input: UpdateViewerInput!
) {
  updateViewer(input: $input) {
    errors
    viewer {
      email
      jobTitle
      department {
        id
        name
      }
      firstName
      lastName
      phone
      initials
      cost
      profiles(first: 10000) {
        edges {
          node {
            id
            name
          }
        }
      }
      role {
        id
        name
      }
      holidayCalendar {
        id
      }
      language
      invited
      profilePictureId
      personLabels(first: 10000) {
        edges {
          node {
            label {
              id
            }
            id
          }
        }
      }
      unseenNotifications
      notificationFrequency
      notifyOnPersonJoin
      notifyOnProjectStatusChange
      notifyOnAssignedProject
      notifyOnProjectDeadline
      notifyOnAssignedTask
      notifyOnAssignedTaskUpdate
      notifyOnTaskDeadline
      notifyOnMention
      notifyOnInvoiceDueDate
      notifyOnInvoiceOverdue
      notifyOnInvoiceDaysOverdue
      notifyOnInvoiceCreatedOrDeleted
      notifyOnInvoiceStatusChange
      notifyOnInvoiceDateReached
      notifyOnInvoicePayment
      notifyOnInvoiceDateChanged
      notifyOnInvoiceDueDateChanged
      notifyOnTaskDescriptionChange
      notifyOnTaskTitleChange
      notifyOnTaskEstimateChange
      notifyOnTaskStartDateChange
      notifyOnTaskEndDateChange
      notifyOnTaskSprintChange
      notifyOnTaskPhaseChange
      notifyOnTaskStatusColumnChange
      notifyOnTaskProjectChange
      notifyOnTaskSubtaskChange
      notifyOnTaskSubtaskEstimateChange
      notifyOnTaskCommentChange
      notifyOnTaskFileChange
      notifyOnTaskBugChange
      notifyOnTaskBlockedChange
      notifyOnTaskRepeatingChange
      notifyOnTimeOffManager
      notifyOnTimeOffOwner
      disableNotifications
      projectDeadlineNotificationPeriod
      taskDeadlineNotificationPeriod
      invoiceNotificationDaysOverdue
      notifyInAppOnProjectStatusChange
      notifyInAppOnPersonJoin
      notifyInAppOnAssignedProject
      notifyInAppOnProjectDeadline
      notifyInAppOnAssignedTask
      notifyInAppOnAssignedTaskUpdate
      notifyInAppOnTaskDeadline
      notifyInAppOnMention
      notifyInAppOnInvoiceDueDate
      notifyInAppOnInvoiceOverdue
      notifyInAppOnInvoiceDaysOverdue
      notifyInAppOnInvoiceCreatedOrDeleted
      notifyInAppOnInvoiceStatusChange
      notifyInAppOnInvoiceDateReached
      notifyInAppOnInvoicePayment
      notifyInAppOnInvoiceDateChanged
      notifyInAppOnInvoiceDueDateChanged
      notifyInAppOnTaskDescriptionChange
      notifyInAppOnTaskTitleChange
      notifyInAppOnTaskEstimateChange
      notifyInAppOnTaskStartDateChange
      notifyInAppOnTaskEndDateChange
      notifyInAppOnTaskSprintChange
      notifyInAppOnTaskPhaseChange
      notifyInAppOnTaskStatusColumnChange
      notifyInAppOnTaskProjectChange
      notifyInAppOnTaskSubtaskChange
      notifyInAppOnTaskSubtaskEstimateChange
      notifyInAppOnTaskCommentChange
      notifyInAppOnTaskFileChange
      notifyInAppOnTaskBugChange
      notifyInAppOnTaskBlockedChange
      notifyInAppOnTaskRepeatingChange
      notifyInAppOnTimeOffManager
      notifyInAppOnTimeOffOwner
      disableInAppNotifications
      projectDeadlineInAppNotificationPeriod
      taskDeadlineInAppNotificationPeriod
      lastSeenInAppNotification
      sendNewsletter
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      sunday
      startDate
      endDate
      timerStartDate
      timerEndDate
      timerTask {
        id
      }
      setToRunningNotificationLastDismissalDate
      gitlabUser {
        integrationUserId
      }
      gitlabServerUser {
        integrationUserId
      }
      githubUser {
        integrationUserId
      }
      unit4UserObject
      jiraCloudId
      jiraServerId
      sageIntacctId
      sageIntacctName
      sageIntacctEmail
      sageIntacctLocationId
      adoUserId
      hiBobId
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateViewerInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobTitle",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v5/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
],
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "DepartmentType",
  "kind": "LinkedField",
  "name": "department",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initials",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cost",
  "storageKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10000
  }
],
v14 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "ProfileTypeConnection",
  "kind": "LinkedField",
  "name": "profiles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProfileTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "profiles(first:10000)"
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": (v6/*: any*/),
  "storageKey": null
},
v16 = [
  (v5/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "HolidayCalendar",
  "kind": "LinkedField",
  "name": "holidayCalendar",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invited",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profilePictureId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unseenNotifications",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notificationFrequency",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnPersonJoin",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnProjectStatusChange",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedProject",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnProjectDeadline",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedTask",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnAssignedTaskUpdate",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskDeadline",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnMention",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDueDate",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceOverdue",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDaysOverdue",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceCreatedOrDeleted",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceStatusChange",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDateReached",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoicePayment",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDateChanged",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnInvoiceDueDateChanged",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskDescriptionChange",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskTitleChange",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskEstimateChange",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskStartDateChange",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskEndDateChange",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSprintChange",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskPhaseChange",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskStatusColumnChange",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskProjectChange",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSubtaskChange",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskSubtaskEstimateChange",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskCommentChange",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskFileChange",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskBugChange",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskBlockedChange",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTaskRepeatingChange",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTimeOffManager",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyOnTimeOffOwner",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableNotifications",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectDeadlineNotificationPeriod",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskDeadlineNotificationPeriod",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNotificationDaysOverdue",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnProjectStatusChange",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnPersonJoin",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnAssignedProject",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnProjectDeadline",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnAssignedTask",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnAssignedTaskUpdate",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskDeadline",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnMention",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnInvoiceDueDate",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnInvoiceOverdue",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnInvoiceDaysOverdue",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnInvoiceCreatedOrDeleted",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnInvoiceStatusChange",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnInvoiceDateReached",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnInvoicePayment",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnInvoiceDateChanged",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnInvoiceDueDateChanged",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskDescriptionChange",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskTitleChange",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskEstimateChange",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskStartDateChange",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskEndDateChange",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskSprintChange",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskPhaseChange",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskStatusColumnChange",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskProjectChange",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskSubtaskChange",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskSubtaskEstimateChange",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskCommentChange",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskFileChange",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskBugChange",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskBlockedChange",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTaskRepeatingChange",
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTimeOffManager",
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notifyInAppOnTimeOffOwner",
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableInAppNotifications",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectDeadlineInAppNotificationPeriod",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskDeadlineInAppNotificationPeriod",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeenInAppNotification",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sendNewsletter",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monday",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tuesday",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "wednesday",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thursday",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "friday",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "saturday",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sunday",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timerStartDate",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timerEndDate",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "concreteType": "Task",
  "kind": "LinkedField",
  "name": "timerTask",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "setToRunningNotificationLastDismissalDate",
  "storageKey": null
},
v116 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "integrationUserId",
    "storageKey": null
  }
],
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "gitlabUser",
  "plural": false,
  "selections": (v116/*: any*/),
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "gitlabServerUser",
  "plural": false,
  "selections": (v116/*: any*/),
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "concreteType": "IntegrationUserType",
  "kind": "LinkedField",
  "name": "githubUser",
  "plural": false,
  "selections": (v116/*: any*/),
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit4UserObject",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraCloudId",
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraServerId",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctId",
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctName",
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctEmail",
  "storageKey": null
},
v126 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sageIntacctLocationId",
  "storageKey": null
},
v127 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "adoUserId",
  "storageKey": null
},
v128 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hiBobId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateViewerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateViewerPayload",
        "kind": "LinkedField",
        "name": "updateViewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "PersonLabelTypeConnection",
                "kind": "LinkedField",
                "name": "personLabels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonLabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "personLabels(first:10000)"
              },
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              (v81/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v84/*: any*/),
              (v85/*: any*/),
              (v86/*: any*/),
              (v87/*: any*/),
              (v88/*: any*/),
              (v89/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v92/*: any*/),
              (v93/*: any*/),
              (v94/*: any*/),
              (v95/*: any*/),
              (v96/*: any*/),
              (v97/*: any*/),
              (v98/*: any*/),
              (v99/*: any*/),
              (v100/*: any*/),
              (v101/*: any*/),
              (v102/*: any*/),
              (v103/*: any*/),
              (v104/*: any*/),
              (v105/*: any*/),
              (v106/*: any*/),
              (v107/*: any*/),
              (v108/*: any*/),
              (v109/*: any*/),
              (v110/*: any*/),
              (v111/*: any*/),
              (v112/*: any*/),
              (v113/*: any*/),
              (v114/*: any*/),
              (v115/*: any*/),
              (v117/*: any*/),
              (v118/*: any*/),
              (v119/*: any*/),
              (v120/*: any*/),
              (v121/*: any*/),
              (v122/*: any*/),
              (v123/*: any*/),
              (v124/*: any*/),
              (v125/*: any*/),
              (v126/*: any*/),
              (v127/*: any*/),
              (v128/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateViewerMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateViewerPayload",
        "kind": "LinkedField",
        "name": "updateViewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "PersonLabelTypeConnection",
                "kind": "LinkedField",
                "name": "personLabels",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonLabelTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonLabel",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v21/*: any*/),
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "personLabels(first:10000)"
              },
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/),
              (v35/*: any*/),
              (v36/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/),
              (v42/*: any*/),
              (v43/*: any*/),
              (v44/*: any*/),
              (v45/*: any*/),
              (v46/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v49/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/),
              (v59/*: any*/),
              (v60/*: any*/),
              (v61/*: any*/),
              (v62/*: any*/),
              (v63/*: any*/),
              (v64/*: any*/),
              (v65/*: any*/),
              (v66/*: any*/),
              (v67/*: any*/),
              (v68/*: any*/),
              (v69/*: any*/),
              (v70/*: any*/),
              (v71/*: any*/),
              (v72/*: any*/),
              (v73/*: any*/),
              (v74/*: any*/),
              (v75/*: any*/),
              (v76/*: any*/),
              (v77/*: any*/),
              (v78/*: any*/),
              (v79/*: any*/),
              (v80/*: any*/),
              (v81/*: any*/),
              (v82/*: any*/),
              (v83/*: any*/),
              (v84/*: any*/),
              (v85/*: any*/),
              (v86/*: any*/),
              (v87/*: any*/),
              (v88/*: any*/),
              (v89/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v92/*: any*/),
              (v93/*: any*/),
              (v94/*: any*/),
              (v95/*: any*/),
              (v96/*: any*/),
              (v97/*: any*/),
              (v98/*: any*/),
              (v99/*: any*/),
              (v100/*: any*/),
              (v101/*: any*/),
              (v102/*: any*/),
              (v103/*: any*/),
              (v104/*: any*/),
              (v105/*: any*/),
              (v106/*: any*/),
              (v107/*: any*/),
              (v108/*: any*/),
              (v109/*: any*/),
              (v110/*: any*/),
              (v111/*: any*/),
              (v112/*: any*/),
              (v113/*: any*/),
              (v114/*: any*/),
              (v115/*: any*/),
              (v117/*: any*/),
              (v118/*: any*/),
              (v119/*: any*/),
              (v120/*: any*/),
              (v121/*: any*/),
              (v122/*: any*/),
              (v123/*: any*/),
              (v124/*: any*/),
              (v125/*: any*/),
              (v126/*: any*/),
              (v127/*: any*/),
              (v128/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateViewerMutation",
    "operationKind": "mutation",
    "text": "mutation updateViewerMutation(\n  $input: UpdateViewerInput!\n) {\n  updateViewer(input: $input) {\n    errors\n    viewer {\n      email\n      jobTitle\n      department {\n        id\n        name\n      }\n      firstName\n      lastName\n      phone\n      initials\n      cost\n      profiles(first: 10000) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n      role {\n        id\n        name\n      }\n      holidayCalendar {\n        id\n      }\n      language\n      invited\n      profilePictureId\n      personLabels(first: 10000) {\n        edges {\n          node {\n            label {\n              id\n            }\n            id\n          }\n        }\n      }\n      unseenNotifications\n      notificationFrequency\n      notifyOnPersonJoin\n      notifyOnProjectStatusChange\n      notifyOnAssignedProject\n      notifyOnProjectDeadline\n      notifyOnAssignedTask\n      notifyOnAssignedTaskUpdate\n      notifyOnTaskDeadline\n      notifyOnMention\n      notifyOnInvoiceDueDate\n      notifyOnInvoiceOverdue\n      notifyOnInvoiceDaysOverdue\n      notifyOnInvoiceCreatedOrDeleted\n      notifyOnInvoiceStatusChange\n      notifyOnInvoiceDateReached\n      notifyOnInvoicePayment\n      notifyOnInvoiceDateChanged\n      notifyOnInvoiceDueDateChanged\n      notifyOnTaskDescriptionChange\n      notifyOnTaskTitleChange\n      notifyOnTaskEstimateChange\n      notifyOnTaskStartDateChange\n      notifyOnTaskEndDateChange\n      notifyOnTaskSprintChange\n      notifyOnTaskPhaseChange\n      notifyOnTaskStatusColumnChange\n      notifyOnTaskProjectChange\n      notifyOnTaskSubtaskChange\n      notifyOnTaskSubtaskEstimateChange\n      notifyOnTaskCommentChange\n      notifyOnTaskFileChange\n      notifyOnTaskBugChange\n      notifyOnTaskBlockedChange\n      notifyOnTaskRepeatingChange\n      notifyOnTimeOffManager\n      notifyOnTimeOffOwner\n      disableNotifications\n      projectDeadlineNotificationPeriod\n      taskDeadlineNotificationPeriod\n      invoiceNotificationDaysOverdue\n      notifyInAppOnProjectStatusChange\n      notifyInAppOnPersonJoin\n      notifyInAppOnAssignedProject\n      notifyInAppOnProjectDeadline\n      notifyInAppOnAssignedTask\n      notifyInAppOnAssignedTaskUpdate\n      notifyInAppOnTaskDeadline\n      notifyInAppOnMention\n      notifyInAppOnInvoiceDueDate\n      notifyInAppOnInvoiceOverdue\n      notifyInAppOnInvoiceDaysOverdue\n      notifyInAppOnInvoiceCreatedOrDeleted\n      notifyInAppOnInvoiceStatusChange\n      notifyInAppOnInvoiceDateReached\n      notifyInAppOnInvoicePayment\n      notifyInAppOnInvoiceDateChanged\n      notifyInAppOnInvoiceDueDateChanged\n      notifyInAppOnTaskDescriptionChange\n      notifyInAppOnTaskTitleChange\n      notifyInAppOnTaskEstimateChange\n      notifyInAppOnTaskStartDateChange\n      notifyInAppOnTaskEndDateChange\n      notifyInAppOnTaskSprintChange\n      notifyInAppOnTaskPhaseChange\n      notifyInAppOnTaskStatusColumnChange\n      notifyInAppOnTaskProjectChange\n      notifyInAppOnTaskSubtaskChange\n      notifyInAppOnTaskSubtaskEstimateChange\n      notifyInAppOnTaskCommentChange\n      notifyInAppOnTaskFileChange\n      notifyInAppOnTaskBugChange\n      notifyInAppOnTaskBlockedChange\n      notifyInAppOnTaskRepeatingChange\n      notifyInAppOnTimeOffManager\n      notifyInAppOnTimeOffOwner\n      disableInAppNotifications\n      projectDeadlineInAppNotificationPeriod\n      taskDeadlineInAppNotificationPeriod\n      lastSeenInAppNotification\n      sendNewsletter\n      monday\n      tuesday\n      wednesday\n      thursday\n      friday\n      saturday\n      sunday\n      startDate\n      endDate\n      timerStartDate\n      timerEndDate\n      timerTask {\n        id\n      }\n      setToRunningNotificationLastDismissalDate\n      gitlabUser {\n        integrationUserId\n      }\n      gitlabServerUser {\n        integrationUserId\n      }\n      githubUser {\n        integrationUserId\n      }\n      unit4UserObject\n      jiraCloudId\n      jiraServerId\n      sageIntacctId\n      sageIntacctName\n      sageIntacctEmail\n      sageIntacctLocationId\n      adoUserId\n      hiBobId\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'f0350160bf735f206247cce281e5957f';
export default node;
